module.exports = __webpack_public_path__ + "img/Xinjiang Uygur-power.111278bb.png";